"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToHSL = exports.generateExtendedChartColors = exports.calculateHSLStep = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var hexToHSL = exports.hexToHSL = function hexToHSL(H) {
  var saturation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var lightness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  // Convert hex to RGB first
  var r = 0,
    g = 0,
    b = 0;
  var length = (H === null || H === void 0 ? void 0 : H.length) || 0;
  switch (length) {
    case 4:
      r = "0x".concat(H[1]).concat(H[1]);
      g = "0x".concat(H[2]).concat(H[2]);
      b = "0x".concat(H[3]).concat(H[3]);
      break;
    case 7:
      r = "0x".concat(H[1]).concat(H[2]);
      g = "0x".concat(H[3]).concat(H[4]);
      b = "0x".concat(H[5]).concat(H[6]);
      break;
  }

  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  var cmin = Math.min(r, g, b);
  var cmax = Math.max(r, g, b);
  var delta = cmax - cmin;
  var h = 0,
    s = 0,
    l = 0;
  if (delta !== 0) {
    if (cmax === r) {
      // eslint-disable-next-line
      h = (g - b) / delta % 6;
    } else if (cmax === g) {
      // eslint-disable-next-line
      h = (b - r) / delta + 2;
    } else {
      // eslint-disable-next-line
      h = (r - g) / delta + 4;
    }
  }

  // eslint-disable-next-line
  h = Math.round(h * 60);
  if (h < 0) {
    // eslint-disable-next-line
    h += 360;
  }

  // eslint-disable-next-line
  l = (cmax + cmin) / 2;
  // eslint-disable-next-line
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);
  return "hsl(".concat(h, ", ").concat(s + saturation, "%, ").concat(l + lightness, "%)");
};
var calculateHSLStep = exports.calculateHSLStep = function calculateHSLStep(correlation) {
  if (correlation > 5 && correlation <= 6) {
    return [-15, -15];
  }
  if (correlation > 4 && correlation <= 5) {
    return [-15, 0];
  }
  if (correlation > 3 && correlation <= 4) {
    return [0, -15];
  }
  if (correlation > 2 && correlation <= 3) {
    return [15, 15];
  }
  if (correlation > 1 && correlation <= 2) {
    return [15, 0];
  }
  if (correlation > 0 && correlation <= 1) {
    return [0, 15];
  }
  return [0, 0];
};
var generateExtendedChartColors = exports.generateExtendedChartColors = function generateExtendedChartColors(colors) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var extendedColors = [];
  var colorsLength = colors.length;
  var step = Math.floor(amount / colorsLength);
  var _loop = function _loop() {
    var _calculateHSLStep = calculateHSLStep(i),
      _calculateHSLStep2 = (0, _slicedToArray2["default"])(_calculateHSLStep, 2),
      sat = _calculateHSLStep2[0],
      lig = _calculateHSLStep2[1];
    colors.forEach(function (color) {
      extendedColors.push(hexToHSL(color, sat, lig));
    });
  };
  for (var i = 1; i <= step; i++) {
    _loop();
  }
  return extendedColors;
};